module.exports = __webpack_public_path__ + "img/dots (1).4a5c3525.svg";